(function () {
  let slides=[];
  if(window.screen.width>1279){
    const slideE = document.querySelectorAll(".promo-slide");
    slideE.forEach((slide) => {
      if(slide.dataset.slide == "true"){
        slides.push(slide);
      }
    })
    if(slides.length <= 1){
      document.querySelector(".promo-banner-prev-btn").style.display = "none";
      document.querySelector(".promo-banner-next-btn").style.display = "none";
    }
  }
  else{
    slides = document.querySelectorAll(".promo-slide");
  }
  
  let count = 0;
  const prev = document
    .querySelector(".promo-banner-prev-btn")
    ?.addEventListener("click", goPrevious);
  const next = document
    .querySelector(".promo-banner-next-btn")
    ?.addEventListener("click", goNext);
  function goPrevious() {
    count = count-1;
    if (count < 0) {
      count = slides.length - 1;
    }
    slideContent();
  }

  function goNext() {
    count = count+1;
    if (count >= slides.length) {
      count = 0;
    }
    slideContent();
  }

  function slideContent() {
    slides.forEach((slide, index) => {
      slide.style.transform = `translateX(-${100 * count}%)`;
    });
  }
})();
